// extracted by mini-css-extract-plugin
export default {"amountSetter":"style--amountSetter--438ac6","amount":"style--amount--522ecf","button":"style--button--8bcac0","active":"style--active--847dd4","passive":"style--passive--96f308"};